















































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import PhoneCountryCodeInput from '@/components/PhoneCountryCodeInput.vue';
import { HomeAndVideoMeeting } from '@/models/CalendarEntries';
import { PhoneCountryCode } from '@/models/PhoneCountryCode';

@Component({
    components: {
        PhoneCountryCodeInput
    }
})
export default class HomeAndVideoMeetingBookingForm extends Vue {
    [x: string]: any;
    @Prop() countryCodes!: PhoneCountryCode[];
    @Prop() loading!: boolean;
    @Prop() pageInfoNote!: string;
    @Prop() meetingType!: string;
    public acceptChecked: boolean = false;
    public formSubmitClicked: boolean = false;
    public formData: HomeAndVideoMeeting = {
        organizationId: '',
        bookedManually: false,
        customerName: '',
        customerEmail: '',
        customerPhone: '',
        customerAddress: '',
        customerPostalCode: '',
        customerCity: '',
        customerMessage: '',
        preferredVisitTime: [],
        preferredContactMethod: 2,
        token: '',
        status: 1,
        meetingType: this.meetingType
    };
    get mailValid(): boolean {
        const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
        if (!reg.test(this.formData.customerEmail)) {
            return false;
        }

        return true;
    }
    get customerNameValid(): boolean {
        //return /^(?=.*\s)[a-zA-ZåäöÅÄÖ\s]+$/.test(this.formData.customerName);
        return this.formData.customerName.length > 0;
    }
    get phoneNumberValid(): boolean {
        return this.formData.customerPhone.toString().length >= 10;
    }
    get formValid(): boolean {
        const formData = this.formData;
        return (
            this.customerNameValid &&
            formData.customerAddress !== '' &&
            formData.customerPostalCode !== '' &&
            formData.customerCity !== '' &&
            this.phoneNumberValid &&
            this.mailValid &&
            formData.preferredVisitTime.length > 0
        );
    }
    get formComplete(): boolean {
        return this.acceptChecked && this.formValid;
    }
    public submitBooking() {
        this.formSubmitClicked = true;
        if (this.formComplete) {
            this.$emit('submitHomeAndVideoMeetingBooking', this.formData);
        }
    }
}
